import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiGetCategory
 */

 export default {
    apiGetAgency: function (token, config) {
        var params = {
            config: config,
        };
        var url = Vue.bzbsConfig.bzbsUrl + "/agency/menu";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, params)
                .then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });

        });
    }
 }
